import { Spacer } from "@hackthenorth/north";
import React from "react";

import { Modal } from "src/shared/components";
import { useMyGooseGamePlayerQuery } from "src/views/goose-games/graphql/hacker/myGooseGamePlayer.generated";
import { StoreItem } from "src/views/goose-games/types";

import FooterActions from "../../../../footerActions";

import PrizeView from "./view";

export interface QuestModalProps {
  isOpen: boolean;
  onClose: () => void;
  item: StoreItem;
}
const PrizeModal: React.FC<QuestModalProps> = ({ isOpen, onClose, item }) => {
  const { data: myGGPlayerData } = useMyGooseGamePlayerQuery();

  return (
    <Modal isOpen={isOpen}>
      <PrizeView
        item={item}
        currentPoints={
          myGGPlayerData ? myGGPlayerData.myGooseGamePlayer.current_points : 0
        }
      />
      <Spacer height={24} />
      <FooterActions confirmText={"Close"} onConfirm={onClose} />
    </Modal>
  );
};

export default PrizeModal;
